import React from "react";
interface IconAcompProps {
  className?: string;
  width?: number;
  fill?: string;
}

const IconAcomp: React.FC<IconAcompProps> = ({ className, width }) => (
  <svg className={className} width={width} viewBox="0 0 100 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="49.7618" cy="8.55253" r="8.30668" fill="#C2282B" />
    <circle cx="8.70658" cy="8.55253" r="8.30668" fill="#C2282B" />
    <rect x="52.9683" y="7.51416" width="32.5" height="2.07667" fill="#C2282B" />
    <rect x="11.9131" y="7.51416" width="33.6332" height="2.07667" fill="#C2282B" />
    <circle cx="91.295" cy="8.55253" r="6.80668" fill="transparent" stroke="#C2282B" strokeWidth="3" />
  </svg>
);
export default IconAcomp;
